import script from "./HelpList.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpList.vue?vue&type=script&setup=true&lang=ts"

import "./HelpList.vue?vue&type=style&index=0&id=58de4bbe&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58de4bbe"]])

export default __exports__